export const COLORS = {
  indigo: "#535ac8",
  green: "#14A44D",
  amber: "#ffa726",
  red: "#DC4C64",
  pageBg: "#f4f6f8",
};
